module.exports = __webpack_public_path__ + "img/step03_01_stand_basic_lebel.76fdc756.png";